import { BusinessUnitVO } from '../../vo/core/business-unit.vo';
import { Model } from '../../model/model';
import { DomainVO } from '../../vo/core/domain.vo';
import { ViewData } from '../../model/view.data';

export class BusinessUnitEngine {

  protected _model: Model = null;
  constructor(model: Model) {
    this._model = model;
  }
  public get model(): Model {
    return this._model as Model;
  }


  /** la BU demandée existe... */
  public get realBusinessUnit(): BusinessUnitVO {
    const buMap: BusinessUnitVO[] = this.model.businessUnitList ? this.model.businessUnitList : [];
    let hit: BusinessUnitVO = null;
    buMap.forEach((bu: BusinessUnitVO) => {
      if (bu.businessUnitCode === this.model.businessUnitCode) {
        hit = bu;
      }
    });
    return hit;
  }



  /** alimentation de la Map de BUs pour le domaine en cours */
  public feed(bus: BusinessUnitVO[]): void {
    if (!bus || bus.length <= 0) {
      return;
    }
    if (!this._model.businessUnitMap) {
      this._model.businessUnitMap = new Map<string, BusinessUnitVO[]>();
    }
    bus.forEach((bu: BusinessUnitVO) => {
      if (!this._model.businessUnitMap.has(bu.domain)) {
        this._model.businessUnitMap.set(bu.domain, []);
      }
      this._model.businessUnitMap.get(bu.domain).push(bu);
      // console.log('buEngine,feed', bu.businessUnitCode);
      this.model.syncService.checkLocal(bu);
    });
    this._model.businessUnitList = bus;
  }

  /**
   * retourne toutes les BUs pour un domaine.
   * @param domainCode : code du domaine
   * @return BusinessUnitVO[]
   */
  public getByDomainCode(domainCode: string): BusinessUnitVO[] {
    let result: BusinessUnitVO[] = null;
    if (this._model.businessUnitMap && this._model.businessUnitMap.has(domainCode)) {
      result = this._model.businessUnitMap.get(domainCode);
    }
    return result;
  }

  /**
   * retourne une BU par son code.
   * @param domainCode : code du domaine
   * @param businessUnitCode : BusinessUnitVO.businessUnitCode cherché
   * @return BusinessUnitVO la bu ayant pour code le paramètre et null si la bu n'existe pas
   */
  public getByBusinessUnitCode(domainCode: string, businessUnitCode: string): BusinessUnitVO {
    let result: BusinessUnitVO = null;
    const domainBus: BusinessUnitVO[] = this.getByDomainCode(domainCode);
    if (domainBus) {
      result = domainBus.find((item: BusinessUnitVO) => item.businessUnitCode === businessUnitCode);
    }
    return result;
  }


  /**
   * L'instance du domain en cours d'administration
   */
  public get currentDomain(): DomainVO {
    return this.getDomainByCode(this.model.currentDomainCode);
  }  

  /**
   * accesseur sur la BU(VO) en cours, valable pour AKM et DOM
   * retourne toujours quelque chose (à minima, la BU d'init de l'app)
   */
  public get currentBU(): BusinessUnitVO {
    let domCode: string = this.model.currentDomainCode || this.model.domainCode;
    let buCode: string = this.model.currentBUCode || this.model.businessUnitCode;
    let result: BusinessUnitVO = this.getByBusinessUnitCode(domCode, buCode);
    if(!result) {
      result = this.getByBusinessUnitCode(domCode, domCode);
    }
    return result;
  }

  /**
   * accesseur sur un domaine par son code
   */
  public getDomainByCode(code: string): DomainVO {
    if(this.model.connectedUser.domains) {
      const dom: DomainVO = this.model.connectedUser.domains.find(domain => domain.code === code);
      if (!!dom) {
        return dom;
      }
    }
    return null;
  } 

  /**
   * pour une liste de BU, retour l'élément racine (unique). Renvoie null en cas d'erreur
   * @param source : collection de BusinessUnitVO
   * @return BusinessUnitVO l'élément racine (unique)
   */
  public getRootFromList(source: BusinessUnitVO[]): BusinessUnitVO {
    let result: BusinessUnitVO = null;

    if (source) {
      const tmpColl = source.filter((item: BusinessUnitVO) => item.parentCode === null);
      if (tmpColl.length === 1) {
        result = tmpColl[0];
      }
    }

    return result;
  }

  /**
   * recherche la BU par défaut du contexte de l'application (alimenté sur cnx ou changement de BU)
   * @return BusinessUnitVO
   */
  public getDefaultContextBU(): BusinessUnitVO {
    let result: BusinessUnitVO = null;
    // à défaut on prend la BU Root si on a pas de bu dans le model
    result = this.getByBusinessUnitCode(this.model.domainCode, this.model.businessUnitCode !== ViewData.wildcardDomain ? this.model.businessUnitCode : this.model.domainCode);
    return result;
  }

}
